// removed by extract-text-webpack-plugin
module.exports = {"boxTitle":"BoxTitle__boxTitle___3QiG7","isSmall":"BoxTitle__isSmall___1fSd9","ellipsis":"BoxTitle__ellipsis___j43w6","noPadding":"BoxTitle__noPadding___2MKfY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/BoxTitle/BoxTitle.scss
// module id = 384
// module chunks = 0